import aliyun from "./common/aliyun";
import map from "./common/map";
import meituan from "./common/meituan";

import datadictionary from "./system/datadictionary";
import module from "./system/module";
import role from "./system/role";
import openplatform from "./system/openplatform";
import openplatformstore from "./system/openplatformstore";
import storeopenplatform from "./system/storeopenplatform";
import customerlog from "./system/customerlog";

import device from "./baseinfo/device";
import customertag from "./baseinfo/customertag";
import customersource from "./baseinfo/customersource";
import customersourceclassify from "./baseinfo/customersourceclassify";
import paytype from "./baseinfo/paytype";
import ratetype from "./baseinfo/ratetype";
import bank from "./baseinfo/bank";
import schedulingclassify from "./baseinfo/schedulingclassify";
import signinfotype from "./baseinfo/signinfotype";

import account from "./hr/account";
import company from "./hr/company";
import post from "./hr/post";
import platformemployee from "./hr/platformemployee";

import room from "./store/room";
import store from "./store/store";
import qrcode from "./store/qrcode";

import item from "./item/item";
import itemclassify from "./item/itemclassify";
import productclassify from "./item/productclassify";
import product from "./item/product";
import serviceclassify from "./item/serviceclassify";
import outserviceclassify from "./item/outserviceclassify";
import servicetopical from "./item/servicetopical";
import service from "./item/service";
import coupon from "./item/coupon";
import card from "./item/card";
import cardstorescope from "./item/cardstorescope";
import giftcard from "./item/giftcard";
import projectmapping from "./item/projectmapping";
import contract from "./item/contract";

import storeproduct from "./project/storeproduct";
import storeservice from "./project/storeservice";
import storecard from "./project/storecard";

import market from "./market/market";
import storemarket from "./market/storemarket";

import customer from "./customer/customer";
import limit from "./customer/limit";
import mycard from "./customer/mycard";
import mycardfreeze from "./customer/mycardfreeze";
import mycoupon from "./customer/mycoupon";
import perferenceinfo from "./customer/perferenceinfo";
import customership from "./customer/customership";
import healthinfo from "./customer/healthinfo";
import customertags from "./customer/customertag";
import customernursinginfo from "./customer/customernursinginfo";
import customernursinglog from "./customer/customernursinglog";
import talkrecording from "./customer/talkrecording";

import couponorder from "./order/couponorder";
import otherorder from "../tmh/order/otherorder";
import otherorderlog from "../tmh/order/otherorderlog";
import meituanorder from "../tmh/order/meituanorder";

import skinreport from "./health/skinreport";
import oilreport from "./health/oilreport";

import reportoilreport from "./report/oilreport";
import memberclassifyreport from "../tmh/report/memberclassifyreport";

import storeemployee from "./employee/storeemployee";
import employeetransfer from "./employee/employeetransfer";
import checkwork from "./employee/checkwork";
import scheduling from "./employee/scheduling";
import schedulingtype from "./employee/schedulingtype";
import rating from "./employee/rating";
import signinfo from "./employee/signinfo";

import applystoreservice from "./apply/applystoreservice";
import applystoreproduct from "./apply/applystoreproduct";
import applystorecard from "./apply/applystorecard";
import applytransfermycard from "./apply/applytransfermycard";
import applyadjustmoneymycard from "./apply/applyadjustmoneymycard";

import financeinfo from "./finance/financeinfo";
import payment from "./finance/payment";
import settlementorder from "./finance/settlementorder";
import settlementorderdetail from "./finance/settlementorderdetail";

import menuclassify from "./menu/menuclassify";
import menuitem from "./menu/menuitem";
import storemenuitem from "./menu/storemenuitem";

export default {
  common: {
    aliyun: aliyun,
    map: map,
    meituan: meituan
  },
  system: {
    datadictionary: datadictionary,
    module: module,
    role: role,
    openplatform: openplatform,
    openplatformstore: openplatformstore,
    storeopenplatform: storeopenplatform,
    customerlog: customerlog
  },
  baseinfo: {
    device: device,
    customertag: customertag,
    customersource: customersource,
    customersourceclassify: customersourceclassify,
    paytype: paytype,
    ratetype: ratetype,
    bank: bank,
    schedulingclassify: schedulingclassify,
    signinfotype: signinfotype
  },
  hr: {
    account: account,
    company: company,
    post: post,
    platformemployee: platformemployee
  },
  store: {
    room: room,
    store: store,
    qrcode: qrcode
  },
  item: {
    item: item,
    itemclassify: itemclassify,
    productclassify: productclassify,
    product: product,
    serviceclassify: serviceclassify,
    outserviceclassify: outserviceclassify,
    servicetopical: servicetopical,
    service: service,
    coupon: coupon,
    card: card,
    cardstorescope: cardstorescope,
    giftcard: giftcard,
    projectmapping: projectmapping,
    contract: contract
  },
  project: {
    storeproduct: storeproduct,
    storeservice: storeservice,
    storecard: storecard
  },
  market: {
    market: market,
    storemarket: storemarket
  },
  customer: {
    customer: customer,
    limit: limit,
    mycard: mycard,
    mycardfreeze: mycardfreeze,
    mycoupon: mycoupon,
    perferenceinfo: perferenceinfo,
    customership: customership,
    healthinfo: healthinfo,
    customertag: customertags,
    customernursinginfo: customernursinginfo,
    customernursinglog:customernursinglog,
    talkrecording:talkrecording,
  },
  employee: {
    storeemployee: storeemployee,
    employeetransfer: employeetransfer,
    checkwork: checkwork,
    scheduling: scheduling,
    rating: rating,
    schedulingtype: schedulingtype,
    signinfo: signinfo
  },
  order: {
    couponorder: couponorder,
    otherorder: otherorder,
    otherorderlog: otherorderlog,
    meituanorder: meituanorder
  },
  health: {
    skinreport: skinreport,
    oilreport: oilreport
  },
  finance: {
    financeinfo: financeinfo,
    settlementorder: settlementorder,
    settlementorderdetail: settlementorderdetail,
    payment: payment
  },
  report: {
    oilreport: reportoilreport,
    memberclassifyreport: memberclassifyreport
  },
  apply: {
    applystoreservice: applystoreservice,
    applystoreproduct: applystoreproduct,
    applystorecard: applystorecard,

    applytransfermycard: applytransfermycard,
    applyadjustmoneymycard: applyadjustmoneymycard
  },

  menu: {
    menuclassify: menuclassify,
    menuitem: menuitem,
    storemenuitem: storemenuitem
  }
};



// WEBPACK FOOTER //
// ./src/api/tmh/index.js